module.exports = __webpack_public_path__ + "1eb0d2cdc19a278d33ad0b55329d9656.svg";